import Tippy from '@tippyjs/react';

import React, { useState, useEffect, memo, useContext, useCallback, useRef } from 'react';
import StockPrice from '@components/StockPrice';
import WatcherDropdown from '@components/UI/Dropdown/WatcherDropdown';
import SearchModal from '@components/UI/SearchModal/SearchModal';
import "./style.css";
import api from '@utils/api';
import { useOnClickOutside } from 'usehooks-ts'
import Swal from 'sweetalert2';
import hmacSHA256 from "crypto-js/hmac-sha256";
import styles from './marketwatch.module.css';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faTrash, faDoorOpen } from '@fortawesome/free-solid-svg-icons';

import { ChartContext } from "@contexts/ChartContext";
import { toast } from 'react-toastify';





// Utility Functions
const custom_number_format = (number) => {
  const SI_SYMBOL = ["", "k", "M", "B", "T", "P", "E"];
  const tier = Math.floor(Math.log10(Math.abs(number)) / 3);
  if (tier === 0) return number.toString();
  const suffix = SI_SYMBOL[tier] || "";
  const scale = Math.pow(10, tier * 3);
  const scaled = number / scale;
  return `${scaled.toFixed(2)}${suffix}`;
};

const number_format = (x) => {
  try {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  } catch (e) {
    return x;
  }
};

export const MarketWatch = memo(() => {
  const {
    watcherOpen,
    setWatcherOpen,
    currentSymbol,
    setActiveWatcherIndex,
    setCurrentSymbol,
    activeWatcherItems,
    setActiveWatcherItems,
    selectedInterval,
    setSelectedInterval,
    mainWidget,
    selectedChart,
    replayMode,
    setReplayMode,
    symbols,
    setSymbols,
    symbolsID,
    tvWidgetsCompReady,
    setTvWidgetsCompReady,
    setSymbolsID,
    currentCandle,
    setCurrentCandle,
    setWatchersTitle,
    watchersTitle,
    activeWatcherIndex,
    watchersUpdated,
    setWatchersUpdated,
    allMarketWatcher,
    setAllMarketWatcher,
    isSearchModalOpen,
    setIsSearchModalOpen,
    translatedTexts,
    templateLoaded,
    t

  } = useContext(ChartContext);

  // Local State
  const [mainSymbol, setMainSymbol] = useState({});
  const [socketItems, setSocketItems] = useState({});

  const [activeWatcherReady, setActiveWatcherReady] = useState(false);
  const [socketSymbolsList, setSocketSymbolsList] = useState({});
  const [mainWS, setMainWs] = useState(null);
  const [toBeDeletedId, setToBeDeletedId] = useState(-1);

  const watcherContainerRef = useRef(null)

  const [dropdownVisible, setDropdownVisible] = useState(false);
  const [position, setPosition] = useState({ x: 0, y: 0 });

  const handleRightClick = (event, id) => {
    event.preventDefault();
    setPosition({
      x: event.pageX,
      y: event.pageY,
    });

    setDropdownVisible(true);
    setToBeDeletedId(id)
  };


  const getWatchers = async () => {
    try {
      const response = await api.get(`/panel/market-watch`);

      const data = response.data;
      setAllMarketWatcher(data.data);

      setWatchersTitle(data.data.map(item => item.name))

    } catch (error) {
      setWatchersUpdated(false)

      console.error("Error fetching market watchers:", error);
    }
  };

  useEffect(() => {


    getWatchers();


  }, []);
  useEffect(() => {

    if (watchersUpdated) {
      getWatchers();

    }
  }, [watchersUpdated]);
  useEffect(() => {
    let newActiveOne = allMarketWatcher?.find(item => item.id == activeWatcherIndex);
    if (allMarketWatcher.length && newActiveOne) {
      setActiveWatcherItems(newActiveOne.items);
      setActiveWatcherReady(true)
      setWatchersUpdated(false)
    }
  }, [activeWatcherIndex, allMarketWatcher]);

  useEffect(() => {


    if (activeWatcherItems.length === 0 || !activeWatcherReady) {
      return;
    }
    if (mainWS?.readyState == WebSocket.OPEN) {
      activeWatcherItems.forEach(item => {

        if (!socketSymbolsList[item.ws_code]) {
          const subscribeMessage = JSON.stringify({
            symbol: item.ws_code,
            type: item.type,
          });
          mainWS.send(subscribeMessage);
          setSocketSymbolsList((prevItems) => ({
            ...prevItems,
            [item.ws_code]: 1,
          }));

        }

      });
    }



  }, [activeWatcherItems, mainWS]);
  useEffect(() => {
    if (activeWatcherItems.length === 0 || !activeWatcherReady) {
      return;
    }


    const privateKey = process.env.REACT_APP_privateKey;
    const publicKey = process.env.REACT_APP_publicKey;
    const text = publicKey + `::` + new Date().getUTCDate();
    const key = hmacSHA256(text, privateKey);

    const ws = new WebSocket(`wss://ws.sourcearena.ir:4075/?hash=${key}&public_key=${publicKey}`);

    ws.onmessage = (event) => {
      try {
        const updatedEvent = JSON.parse(event.data);
        const { type, data, code } = updatedEvent;

        setSocketItems((prevItems) => ({
          ...prevItems,
          [code]: data,
        }));



      } catch (err) {
        console.error("Error parsing WebSocket message:", err);
      }
    };

    ws.onopen = () => {
      setMainWs(ws)

    };

    ws.onclose = () => {
      console.log('WebSocket disconnected');
    };

    return () => {
      ws.close();
    };
  }, [activeWatcherReady]);

  useEffect(() => {
    if (templateLoaded) {
      try {
        const item = allMarketWatcher.map(item => item.items).flat().find(item => item.name === currentSymbol);

        if (item) {
          setMainSymbol(item);
        } else {
          setMainSymbol({})
        }
      } catch (e) {
      }
    }
  }, [currentSymbol, allMarketWatcher, templateLoaded]);

  // Handle Item Click
  const handleItemClick = (async (item) => {
    if (mainWidget && mainWidget.activeChart) {
      if (!symbols.includes(item.name)) {


        mainWidget.activeChart().setSymbol(item.name);
        setCurrentSymbol(item.name);
        setReplayMode(false);

        setTvWidgetsCompReady(false)
        setSymbols(prevSymbols => {
          const updated = [...prevSymbols];
          updated[selectedChart] = item.name;
          return updated;
        });

        setSymbolsID(prevSymbolsID => {
          const updated = [...prevSymbolsID];
          updated[selectedChart] = `${selectedChart}@${item.name}`;
          return updated;
        });
      } else {
        toast.error(t("This ticker already exists in chart"));
      }
    }
  });


  const deleteWatcherItem = async (id) => {
    try {
      const response = await api.delete(`/panel/market-watch/items/${id}`).then(res => res.data);
      if (response.status) {
        toast.success(response.message);
        setWatchersUpdated(true)
      } else {
        toast.error(response.message);
      }

    } catch (error) {
      toast.error("Error deleting watcher item", error);
      console.log(error)
      return false;
    }
  };

  const deleteWatcher = async (id) => {
    try {
      const response = await api.delete(`/panel/market-watch/${id}`).then(res => res.data);
      if (response.status) {
        toast.success(response.message);
        setWatchersUpdated(true)
        setActiveWatcherIndex("bourse-50")

      } else {
        toast.error(response.message);
      }

    } catch (error) {
      toast.error("Error deleting watcher", error);
      console.log(error)
      return false;
    }
  };
  const deleteWatcherItemSWal = useCallback(() => {
    Swal.fire({
      title: translatedTexts?.swal?.are_you_sure,
      text: translatedTexts?.swal?.no_revertable,
      icon: 'warning',
      customClass: {
        container: translatedTexts?.class?.direction,
        popup: 'bg-tt-100 text-tt-content dir-center',
        cancelButton: 'swal-btn-cancel',

      },


      showCancelButton: true,
      cancelButtonColor: '#3085d6',
      confirmButtonColor: '#d33',
      confirmButtonText: translatedTexts?.swal?.delete,
      cancelButtonText: translatedTexts?.swal?.cancel,
    }).then(async (result) => {
      if (result.isConfirmed) {
        let data = deleteWatcherItem(toBeDeletedId);

      }
    });
  }, [toBeDeletedId, translatedTexts]);

  const deleteWatcherSWal = useCallback(() => {
    Swal.fire({
      title: translatedTexts?.swal?.are_you_sure,
      text: translatedTexts?.swal?.watchlist_delete_warning?.replace(":watchlist", allMarketWatcher?.find(item => item.id == activeWatcherIndex)?.name),
      icon: 'warning',
      customClass: {
        container: translatedTexts?.class?.direction,
        popup: 'bg-tt-100 text-tt-content dir-center',
        cancelButton: 'swal-btn-cancel',

      },


      showCancelButton: true,
      cancelButtonColor: '#3085d6',
      confirmButtonColor: '#d33',
      confirmButtonText: translatedTexts?.swal?.delete,
      cancelButtonText: translatedTexts?.swal?.cancel,
    }).then(async (result) => {
      if (result.isConfirmed) {
        let data = deleteWatcher(activeWatcherIndex);

      }
    });
  }, [activeWatcherIndex, allMarketWatcher, translatedTexts]);
  useOnClickOutside(watcherContainerRef, () => { setDropdownVisible(false); })

  const watcherList = activeWatcherItems.map(item => (




    <li
      onClick={() => handleItemClick(item)}
      onContextMenu={(e) => { handleRightClick(e, item.id) }}
      key={item.name}
      className={`grid cols-3 list-group-item bg-tt-300 box-symbol cursor-pointer
        relative flex justify-between items-center text-center border-2 hover:border-primary rounded-lg p-2.5 pr-6 border-primary mt-1 mb-1 ${currentSymbol === item.name ? "active-item" : ""
        }`}
    >
      <div className="flex items-center truncate">
        <span className="cursor-pointer ml-1 text-right">{item.name}</span>
      </div>
      <div dir="ltr" className="truncate text-center">
        {(() => {
          let ws_code = item.ws_code;
          ws_code = ws_code.split("-")[0]
          let data = socketItems[ws_code]
          let displayItem, prop, decimals;

          if (item.type === "bourse") {

            if (data?.basis) {
              displayItem = data.basis;
              prop = "close";
            } else {
              displayItem = item.data;
              prop = "price";
            }
            decimals = 0;
          } else if (item.type === "crypto") {



            if (data) {
              displayItem = data;
              prop = "PRICE";
            } else {
              displayItem = item.data;
              prop = "price";
            }
            decimals = 2;
          } else {

            if (data) {
              displayItem = data;
              prop = "c";
            } else {
              displayItem = item.data;
              prop = "price";
            }
            decimals = 4;
          }

          return <StockPrice item={displayItem} prop={prop} decimals={decimals} number_format={true} />;
        })()}
      </div>
      <div id={`${item.name}-change`} dir="ltr" className="text-center">
        <span className="truncate">



          {(() => {
            let displayItem;
            let toShowObject = {};
            let ws_code = item.ws_code;
            ws_code = ws_code.split("-")[0]
            let data = socketItems[ws_code]

            if (item.type === "bourse") {



              if (data?.basis?.close) {
                displayItem = (data.basis.close - item.data.open) / item.data.open;
              } else {
                displayItem = (item.data.price - item.data.open) / item.data.open;
              }



            } else if (item.type === "crypto") {


              if (data) {

                displayItem = (data.PRICE - item.data.open) / item.data.open;
              }


            } else {

              if (data) {
                displayItem = (data.c - item.data.open) / item.data.open;
              } else {
                displayItem = (item.data.price - item.data.open) / item.data.open;
              }
            }
            toShowObject["change"] = Math.round(10000 * displayItem) / 100;
            return <StockPrice item={toShowObject} prop={"change"} decimals={2} append={"%"} />;

          })()}
        </span>
      </div>

    </li>
  ));

  return (
    <div
      className={`${styles.mw__pane}  ${watcherOpen ? "" : "hidden"}`}
      id="slider-bar-content"

    >
      <div className="w-full h-full">
        <section className="p-2 pr-1 pb-0 h-full">
          <div className="default-theme h-full splitpanes splitpanes--horizontal">
            <div className="splitpanes__pane bg-tt-100" style={{ width: '95%' }}>
              <section className="watch-list flex flex-col w-full" style={{ height: "97vh" }}>
                {/* Header Section */}
                <div className="flex items-center justify-between">
                  <div className="flex-grow justify-between items-center bg-tt-300 rounded-lg">
                    <div className="flex justify-between items-center px-3 py-2">
                      <span className="title-symbol truncate">{(() => {
                        if (Object.keys(mainSymbol).length) {
                          return currentSymbol

                        }
                        return "-"

                      })()}</span>
                      <span className="price-symbol text-left flex">
                        <span className='ml-2'>
                          {mainSymbol && (() => {
                            let item = mainSymbol
                            if (Object.keys(mainSymbol).length) {




                              let data = socketItems[item.ws_code]
                              let displayItem, prop, decimals;

                              if (item.type === "bourse") {
                                if (data?.basis) {
                                  displayItem = data.basis;
                                  prop = "close";
                                } else {
                                  displayItem = item.data;
                                  prop = "price";
                                }
                                decimals = 0;
                              } else {

                                if (data) {
                                  displayItem = data;
                                  prop = "c";
                                } else {
                                  displayItem = item.data;
                                  prop = "price";
                                }
                                decimals = 4;
                              }

                              return <StockPrice item={displayItem} prop={prop} decimals={decimals} number_format={true} />;
                            }
                            return "-"
                          })()}
                        </span>

                      </span>
                    </div>
                  </div>
                </div>

                {/* Current Candle Information */}
                {/*<div className={styles.ohlcContainer}>
                  <div className="text-sm flex">
                    <span>O: </span>
                    <span className="pr-1">
                      {currentCandle[`${currentSymbol}${selectedInterval}`]?.open || "-"}
                    </span>
                  </div>
                  <div className="text-sm flex">
                    <span>H: </span>
                    <span className="pr-1">
                      {currentCandle[`${currentSymbol}${selectedInterval}`]?.high || "-"}
                    </span>
                  </div>
                  <div className="text-sm flex">
                    <span>L: </span>
                    <span className="pr-1">
                      {currentCandle[`${currentSymbol}${selectedInterval}`]?.low || "-"}
                    </span>
                  </div>
                  <div className="text-sm flex">
                    <span>C: </span>
                    <span id="price-close" className="pr-1">
                      {currentCandle[`${currentSymbol}${selectedInterval}`]?.close || "-"}
                    </span>
                  </div>
                </div>
                */}

                {/* Watch List Menu */}


                <div
                  id="watch-list-menu"
                  className="flex justify-between items-center w-full mb-2 z-1 mt-2"
                >
                  <WatcherDropdown />

                  <div className="flex items-center">

                    <Tippy content={translatedTexts?.watchlist?.add_ticker_title} placement="bottom" animation="scale" duration={0}
                    >

                      <div
                        onClick={() => {
                          if (activeWatcherIndex == "bourse-50") {
                            toast.error("اضافه کردن نماد به دیده بان پیشفرض مجاز نیست، دیده بان دیگری را انتخاب کنید")


                            return;
                          }
                          setIsSearchModalOpen(true)
                        }}
                        className="flex items-center justify-between cursor-pointer rounded btn-grey-hover p-1">
                        <span className="font-normal mx-1">{translatedTexts?.watchlist?.add_ticker}  </span>
                      </div>

                    </Tippy>


                    <Tippy content={translatedTexts?.watchlist?.remove_watchlist_title} placement="bottom" animation="scale" duration={0}>



                      <div
                        onClick={() => deleteWatcherSWal(true)}
                        className="flex items-center justify-between cursor-pointer rounded btn-grey-hover p-1">
                        <span className="font-normal mx-1">{translatedTexts?.watchlist?.remove_watchlist}</span>
                      </div>

                    </Tippy>



                  </div>
                </div>

                {/* Watch List Headers */}
                <div className="grid cols-3 pr-2 pl-2  mb-3 mt-auto" >
                  <span className="text-right">{translatedTexts?.watchlist?.symbol}</span>
                  <span className="text-center text-sm">{translatedTexts?.watchlist?.price}</span>
                  <span className="text-center text-sm">{translatedTexts?.watchlist?.change}</span>
                  {/* <span className="text-left text-sm ml-3">حجم</span> */}
                </div>

                {/* Watch List Items */}
                <div className="watch-list-items overflow-y-auto text-9 pb-2 h-full mt-auto" >
                  <div className="list-group h-full">
                    <ul className="h-full overflow-auto pl-2" >
                      {watcherList}

                      {dropdownVisible && (
                        <div
                          ref={watcherContainerRef}
                          onContextMenu={(e) => e.preventDefault()}
                          style={{
                            top: position.y,
                            left: position.x,
                          }}
                          className='absolute mt-1  rounded-md bg-tt-100 shadow-lg z-50'

                        >
                          <div className="py-1 max-h-60 overflow-auto text-tt-content ">

                            <div
                              key="delete"
                              onClick={deleteWatcherItemSWal}
                              className="w-full text-left px-4 py-2 text-sm  hover:bg-indigo-600 hover:text-white flex items-center justify-between cursor-pointer"
                            >
                              <FontAwesomeIcon icon={faTrash} className='ml-2' />
                              {translatedTexts?.watchlist?.delete}



                            </div>
                          </div>

                        </div>
                      )}
                    </ul>
                  </div>
                </div>
              </section>
            </div>
          </div>
        </section>
      </div>
      <SearchModal
        isOpen={isSearchModalOpen}
        onClose={() => setIsSearchModalOpen(false)}
      />
    </div>
  );
});


